import React from 'react';
import { Typography, Skeleton } from '@mui/material';
import { FolderOpenRounded, VpnKeyRounded } from '@mui/icons-material';
import { IMiMateria } from '../../../types/miRecurso';
import {
	MATERIA_COLORS,
	CardContainer,
	ColorStripe,
	CardBody,
	CardTopRow,
	MateriaAvatar,
	ResourceCountBadge,
	AddMateriaCardContainer,
	AddIconCircle,
} from './styles';

interface MateriaAlumnoCardProps {
	materia: IMiMateria;
	colorIndex: number;
	onSelect: () => void;
}

const MateriaAlumnoCard: React.FC<MateriaAlumnoCardProps> = ({
	materia,
	colorIndex,
	onSelect,
}) => {
	const colors = MATERIA_COLORS[colorIndex % MATERIA_COLORS.length];

	const initials = materia.nombre
		.split(' ')
		.filter((w) => w.length > 2)
		.slice(0, 2)
		.map((w) => w[0])
		.join('')
		.toUpperCase()
		.padEnd(2, materia.nombre[1]?.toUpperCase() ?? 'X');

	return (
		<CardContainer onClick={onSelect}>
			<ColorStripe stripecolor={colors.stripe} />
			<CardBody>
				<CardTopRow>
					<MateriaAvatar bgcolor={colors.bg} accentcolor={colors.accent}>
						{initials}
					</MateriaAvatar>
					<ResourceCountBadge accentcolor={colors.accent}>
						<FolderOpenRounded style={{ fontSize: '0.9rem' }} />
						{materia.resourceCount} {materia.resourceCount === 1 ? 'recurso' : 'recursos'}
					</ResourceCountBadge>
				</CardTopRow>

				<Typography variant='subtitle1' fontWeight={700} noWrap title={materia.nombre}>
					{materia.nombre}
				</Typography>

				<Typography variant='caption' color='text.secondary' noWrap>
					{materia.docenteNombre}
				</Typography>
			</CardBody>
		</CardContainer>
	);
};

export const MateriaAlumnoCardSkeleton: React.FC = () => (
	<CardContainer style={{ cursor: 'default', pointerEvents: 'none' }}>
		<Skeleton variant='rectangular' height={6} />
		<CardBody>
			<CardTopRow>
				<Skeleton variant='rounded' width={52} height={52} style={{ borderRadius: 12 }} />
				<Skeleton variant='rounded' width={90} height={26} style={{ borderRadius: 20 }} />
			</CardTopRow>
			<Skeleton variant='text' width='65%' height={28} />
			<Skeleton variant='text' width='45%' height={20} />
		</CardBody>
	</CardContainer>
);

interface IngresarCodigoCardProps {
	onClick: () => void;
}

export const IngresarCodigoCard: React.FC<IngresarCodigoCardProps> = ({ onClick }) => (
	<AddMateriaCardContainer onClick={onClick}>
		<AddIconCircle>
			<VpnKeyRounded />
		</AddIconCircle>
		<Typography variant='body2' fontWeight={600} color='primary'>
			Ingresar código
		</Typography>
		<Typography variant='caption' color='text.secondary' align='center'>
			¿Tienes un código de materia? Ingrésalo aquí para acceder a sus recursos
		</Typography>
	</AddMateriaCardContainer>
);

export default MateriaAlumnoCard;
